import { render } from "./NotificationContainer.vue?vue&type=template&id=13306f62"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"

import "./NotificationContainer.vue?vue&type=style&index=0&id=13306f62&lang=css"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__